export type Membership = {
  tenantId: string;
  tenantSlug: string;
  tenantName: string;
  tenantMode: 'PRODUCTION' | 'DEMO';
  role: 'SUPER_ADMIN' | 'ADMIN' | 'AGENCY' | 'AGENCY_DEMO' | 'LOCATION_USER';
  status: 'ACTIVE' | 'INVITED' | 'DISABLED';
};

export type CurrentUser = {
  id: string;
  email: string;
  name: string;
  globalRole: 'USER' | 'SUPER_ADMIN';
  memberships: Membership[];
};

export type AuthState = {
  accessToken: string | null;
  user: CurrentUser | null;
  activeTenantId: string | null;
};

const STORAGE_KEY = 'gmb_whitelabel_auth_state_v1';

export function loadAuthState(): AuthState {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return {
        accessToken: null,
        user: null,
        activeTenantId: null,
      };
    }

    const parsed = JSON.parse(raw) as AuthState;
    return {
      accessToken: parsed.accessToken ?? null,
      user: parsed.user ?? null,
      activeTenantId:
        parsed.activeTenantId ?? parsed.user?.memberships?.[0]?.tenantId ?? null,
    };
  } catch {
    return {
      accessToken: null,
      user: null,
      activeTenantId: null,
    };
  }
}

export function saveAuthState(state: AuthState): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
}

export function clearAuthState(): void {
  localStorage.removeItem(STORAGE_KEY);
}
